import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Select from 'react-select';
import { Map } from 'immutable';
import { timezonesSelector } from '../../../reducers/timezones';

const TimeZoneEditorSelector = createSelector(
  [timezonesSelector],
  timeZoneMap => ({
    timeZoneMap,
  }),
);

@connect(TimeZoneEditorSelector)
export default class TimeZoneEditor extends Component {
  static propTypes = {
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    input: PropTypes.object,
    timeZoneMap: PropTypes.instanceOf(Map),
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
  };

  setListOptions = value => value && value.split(/\r?\n/);

  populateOptions = () => {
    const { timeZoneMap } = this.props;

    return timeZoneMap
      .reduce(
        (prev, cur) => {
          const value = cur.get('id');
          const label = cur.get('text');
          prev.push({
            label,
            value,
          });
          return prev;
        },
        [
          {
            label: 'No Time Zone Set',
            value: 0,
          },
        ],
      )
      .sort((a, b) => a.value - b.value);
  };

  render = () => {
    const {
      input,
      wrapperClassName,
      wrapperStyle,
      containerClassName,
      containerStyle,
    } = this.props;

    const displayEditor = (
      <div className={wrapperClassName} style={wrapperStyle}>
        <div className={containerClassName} style={containerStyle}>
          <Select
            ref={input1 => {
              this.theInput = input1;
            }}
            multi={false}
            simpleValue
            autoBlur
            joinValues
            clearable={false}
            searchable
            matchProp={'label'}
            matchPos={'any'}
            onBlurResetsInput={false}
            onCloseResetsInput={false}
            onBlurSelectsFocusedOption
            // backspaceRemoves={false}
            cache={false}
            /* className="form-control c-select"*/
            style={{ display: 'inline-block' }}
            {...input}
            options={this.populateOptions()}
            onBlur={() => {
              this.theInput.closeMenu();
            }}
          />
        </div>
      </div>
    );

    return displayEditor;
  };
}



// WEBPACK FOOTER //
// ./src/components/types/TimeZone/TimeZoneEditor.js